import React from 'react'

/** @deprecated use `upload` icon with a `size` props instead */
const UploadThin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width='11'
      height='11'
      viewBox='0 0 11 11'
      name='icon-upload-thin'
      fill='currentColor'
    >
      {' '}
      <path d='M1.4375 10.5C1.1875 10.5 0.96875 10.4062 0.78125 10.2188C0.59375 10.0312 0.5 9.8125 0.5 9.5625V7.32812H1.4375V9.5625H9.5625V7.32812H10.5V9.5625C10.5 9.8125 10.4062 10.0312 10.2188 10.2188C10.0312 10.4062 9.8125 10.5 9.5625 10.5H1.4375ZM5.03125 8.10937V2.3125L3.15625 4.1875L2.48438 3.51562L5.5 0.5L8.51562 3.51562L7.84375 4.1875L5.96875 2.3125V8.10937H5.03125Z' />
    </svg>
  )
}

export default UploadThin
